import { useCallback } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import {
  DISPLAY_NAME,
  type SnackbarScopedProps,
  useSnackbarContext,
} from '../../snackbar'
import type { SnackbarTypes } from '../../snackbar.types'

type SnackbarIconProps = TIconProps

export const SnackbarIcon = (props: SnackbarIconProps) => {
  const { symbol, __scopeSnackbar } =
    props as SnackbarScopedProps<SnackbarIconProps>

  const { type } = useSnackbarContext(DISPLAY_NAME, __scopeSnackbar)

  const mapper: Record<SnackbarTypes, TIconProps['color']> = {
    success: 'colorTextSuccessAlternative',
    informative: 'colorTextInformativeAlternative',
    warning: 'colorTextWarningAlternative',
    danger: 'colorTextDangerAlternative',
    'brand-accent': 'colorActionTextOnbrandDefault',
  }

  const mapVariantColor = useCallback((): TIconProps['color'] => {
    return mapper[type]
  }, [type])

  return (
    <Icon
      symbol={symbol}
      size="small"
      color={mapVariantColor()}
      data-testid="snackbar-icon"
    />
  )
}
